import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import { RootContainer } from "../../styles/Container.style";
import { Image } from "../Informations.page";

export default function TermOfUsePage() {
  const viewportWidth = usePwaViewportWidth();

  return (
    <RootContainer $alignItem="center">
      <Image $width={viewportWidth + "px"} src="/informations/term-of-use.png" />
    </RootContainer>
  );
}
